// @flow
import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import * as selectors from '../../../reducers';
import { OMNISEARCH_RESULT_TYPES } from '../../Omnisearch';
import { generateFetcher } from '../../Omnisearch/utils';
import { RenderTaggedInput } from '../../FieldRenderer';
import OmnisearchResult from '../../OmnisearchResult';
import OmnisearchLoadingResults from '../../OmnisearchLoadingResults';

import styles from './notificationAddressees.css';


type NotificationAddresseesPropTypes = {
  fetchItems: string => Promise<Array<Object>>,
    title: string,
};

const NotificationAddressees = ({
  fetchItems,
  title = '',
}: NotificationAddresseesPropTypes) => (
    <div className={styles.NotificationAddresseesContainer}>
      <div className={styles.notificationAddressees}>
        <div className={styles.to}>
          {title}
        </div>
        <Field
          name="user_groups"
          className={styles.tags}
          containerClassName={styles.tags}
          fetchItems={fetchItems}
          inputDebounce={300}
          renderLoading={() => <OmnisearchLoadingResults size="small" count={3} />}
          renderItem={
            (item, isHighlighted) => (
              <OmnisearchResult
                {...item}
                key={item.value}
                isSelected={isHighlighted}
                size="small"
              />
            )
          }
          inputProps={{
            isClearContained: true,
            clearMargins: true,
          }}
          component={RenderTaggedInput}
          size="small"
        />
      </div>
    </div>
  );

export default connect(
  (state) => {
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const token = selectors.getToken(state);
    return {
      fetchItems: generateFetcher(
        OMNISEARCH_RESULT_TYPES.everything,
        schoolId,
        token,
      ),
    };
  },
  undefined,
)(NotificationAddressees);



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationPopoverContent/NotificationAddressees/index.jsx